module.exports = __webpack_public_path__ + "media/images/toyotaLogo@2x-540f9b25b5a393765126189cc2d500ea.png";